import {
  Button,
  Container,
  FormField,
  Header,
  Input,
  Select,
  SpaceBetween
} from '@cloudscape-design/components';
import { OptionDefinition } from '@cloudscape-design/components/internal/components/option/interfaces';
import { useEffect, useState } from 'react';

export const ProjectForm = (props: {
  createNewProject: (
    projectName: string,
    projectDescription: string,
    projectType: string
  ) => void;
  setFolderModal: (arg: boolean) => void;
  projectType?: string | null;
  origin?: string;
}) => {
  const [projectName, setProjectName] = useState<string>('');
  const [projectDescription, setProjectDescription] = useState<string>('');
  const [projectType, setProjectType] = useState<OptionDefinition>({
    label: 'Workspace',
    value: 'workspace'
  });

  useEffect(() => {
    if (props?.projectType) {
      switch (true) {
        case props?.projectType === 'information_request':
          setProjectType({
            label: 'Information Request',
            value: 'information_request'
          });
          break;
        case props?.projectType === 'workspace':
          setProjectType({
            label: 'Workspace',
            value: 'workspace'
          });
          break;
      }
    }
    if (props?.origin === 'gap') {
      setProjectType({
        label: 'Information Request',
        value: 'information_request'
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleReset = () => {
    setProjectDescription('');
    setProjectName('');
    setProjectType({
      label: 'Workspace',
      value: 'workspace'
    });
  };

  return (
    <Container
      header={<Header>Create New Project</Header>}
      footer={
        <SpaceBetween size={'xs'} direction="horizontal">
          <Button onClick={() => props.setFolderModal(false)}>Cancel</Button>
          <Button
            disabled={!projectName || !projectType.value}
            onClick={() => {
              props.createNewProject(
                projectName,
                projectDescription,
                projectType.value!
              );
              // handleReset();
            }}
          >
            Create Project
          </Button>
        </SpaceBetween>
      }
    >
      <SpaceBetween size={'xs'}>
        <FormField label="Project Name">
          <Input
            value={projectName}
            onChange={(event) => setProjectName(event.detail.value)}
          />
        </FormField>
        <FormField label="Project Description - Optional">
          <Input
            value={projectDescription}
            onChange={(event) => setProjectDescription(event.detail.value)}
          />
        </FormField>
        {!props.origin && (
          <>
            <p className="text-2xl text-center">Select Type</p>
            <div className="flex justify-around  w-full">
              {[
                {
                  title: 'Document Project',
                  value: 'workspace',
                  description:
                    'Upload and analyze your internal documents. Extract requirements, summarize information and create AI findings. '
                },
                {
                  title: 'Questionnaire Project',
                  value: 'information_request',
                  description:
                    'Import spreadsheet questionnaires and let AI help you complete it. Use for vendor questionnaires, customer requests, audits and assessments.'
                }
              ].map((option) => {
                const isSelected = projectType.value === option.value;
                return (
                  <button
                    key={option.value}
                    type="button"
                    onClick={() =>
                      setProjectType({
                        label: option.title,
                        value: option.value
                      })
                    }
                    className={`w-[45%] text-left border rounded-lg p-4 transition shadow-sm hover:shadow-md focus:outline-none ${
                      isSelected
                        ? 'border-blue-600 ring-2 ring-blue-100 bg-blue-50'
                        : 'border-gray-200 bg-white'
                    }`}
                  >
                    <p className="text-base font-semibold text-gray-900">
                      {option.title}
                    </p>
                    <p className="text-sm text-gray-700 mt-2">
                      {option.description}
                    </p>
                    <p
                      className={`mt-3 inline-flex items-center text-sm font-medium ${
                        isSelected ? 'text-blue-700' : 'text-gray-600'
                      }`}
                    >
                      {isSelected ? 'Selected' : 'Select this option'}
                    </p>
                  </button>
                );
              })}
            </div>
          </>
        )}
        {/* {!props?.origin && (
          <div>
            <p>
              You need to frequently refer to the documents to manage your
              obligations and track changes in requirements -{' '}
              <b>Choose Workspace</b>
            </p>
            <p>
              You need to research and respond to questions in a document,
              research and reuse prior responses -{' '}
              <b>Choose Information Request</b>
            </p>
          </div>
        )} */}
        {props?.origin === 'gap' && (
          <div>
            <p>
              The destination folder for Gap analysis is a Questionnaire
              project.
            </p>
          </div>
        )}
      </SpaceBetween>
    </Container>
  );
};
